module.exports = __webpack_public_path__ + "img/bg_3.4a8cdfae.jpg";